<template>
  <div class="common-empty-box">
    <bj-empty class="empty-page">
      <template>
        <div class="description-box">
          <div class="text-box empty-text">抱歉，没有找到相关内容</div>
          <div class="format-box">
            <div>当前支持的格式：gltf、glb、rfa、fbx、.obj、.obj.zip</div>
            <el-tooltip
              placement="top-start"
              popper-class="common-panel-tooltip-box"
              :effect="$theme.tooltipKey()"
            >
              <div slot="content">
                若需要显示obj文件的材质信息，您需要将obj文件、mtl文件和贴图文件打包，并修改后缀名为.obj.zip后再上传
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-wenhao1" class="icon" />
              </div>
            </el-tooltip>
          </div>
        </div>
      </template>
    </bj-empty>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: Function,
    uploadFile: Function,
  },
  methods: {
    isVisible() {
      if (this.isChecked) {
        return this.isChecked("Project.ComponentLibrary.Public.Upload");
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.common-empty-box {
  .upload-btn {
    padding: 0px 30px;
  }

  .description-box {

    .text-box {
      color: #909399;
    }

    .format-box {
      display: flex;
      margin-top: 10px;

      .icon-box {
        margin-left: 5px;
      }
    }
  }
}
</style>